import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import useAuth from '../hooks/useAuth';
import Forbidden from '../pages/super-admin/Forbidden';

// Mirror of the backend's IsSuperAdminOnly permission. Authenticated but
// non-superuser visitors render an in-app 403 page (Forbidden) rather than
// being silently redirected — that matches the plan's literal verification
// criterion ("returns 403 for student, 403 for backoffice"). Unauthenticated
// visitors still get bounced to /login with the redirect-back trail so they
// don't lose their destination.
const SuperAdminRoute = () => {
  const { authenticated, initializing } = useAuth();
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();

  if (initializing) return null;

  if (!authenticated) {
    return (
      <Navigate
        replace
        to={`/login?redirectUrl=${location.pathname}`}
      />
    );
  }

  if (user?.type !== 'superuser') {
    return <Forbidden />;
  }

  return <Outlet />;
};

export default SuperAdminRoute;
